import * as yup from "yup";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { IoMailOutline } from "react-icons/io5";
import { FaCircleNotch } from "react-icons/fa";
import ReactSelect from "../../../components/common/ReactSelect";
import Datepicker from "./../../../components/common/Datepicker";
import Toaster from "./../../../components/common/Toaster";
import accountService from "../../../services/accountService";
import moment from "moment";

const income_types = [
  { value: "Professional", label: "Professional" },
  { value: "Business", label: "Business" },
];

const statuses = accountService.getAccountStatuses();

const schema = yup.object({
  status: yup.object().shape({
    label: yup.string().required("Please select status."),
    value: yup.string().required("Please select status."),
  }),
  income_type: yup.object().shape({
    label: yup.string().required("Please select income type."),
    value: yup.string().required("Please select income type."),
  }),
  year: yup.string().required("Please select year."),
});

const SwornDeclarationForm = ({ isLoading, setLoading, onSuccess }) => {
  const [initialYear] = useState(
    Date.parse(moment(new Date(), "YYYY").add(1, "year").toISOString())
  );

  const {
    register,
    handleSubmit,
    control,
    setValue,
    clearErrors,
    formState: { errors },
  } = useForm({ resolver: yupResolver(schema) });

  const onSubmit = async (info) => {
    try {
      setLoading(true);

      const item = { ...info };
      item["income_type"] = info.income_type.value;
      item["status"] = info.status.value;
      item["year"] = info.year.slice(info.year.length - 4);

      console.log(item);

      await accountService.generateSwornDeclarationDraftAsync(item);
      Toaster.Success("Sworn Declaration Sent Successfully!");

      setLoading(false);
      onSuccess();
    } catch (ex) {
      console.log(ex);
      Toaster.Error("Something went wrong.");
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="p-8 space-y-6">
      <div className="grid grid-cols-2">
        <div className="col-span-2">
          <ReactSelect
            id="statuses-dropdown"
            name="status"
            title="Status"
            options={statuses}
            control={control}
            register={register("statuses")}
            errors={errors}
          />
        </div>
      </div>
      <div className="grid grid-cols-2">
        <div className="col-span-2">
          <ReactSelect
            id="income-type-dropdown"
            name="income_type"
            title="Income Type"
            options={income_types}
            control={control}
            register={register("income_type")}
            errors={errors}
          />
        </div>
      </div>
      <div className="grid grid-cols-2">
        <div className="col-span-1">
          <Datepicker
            id="year-datepicker"
            name="year"
            title="Year"
            dateFormat="YYYY"
            setValue={setValue}
            clearErrors={clearErrors}
            register={register("year")}
            timeFormat={false}
            initialValue={initialYear}
            errors={errors}
            readOnly
          />
        </div>
      </div>
      <div className="grid grid-cols-2">
        <div className="col-span-2">
          <p className="text-sm text-gray-400">
            Note: This will generated sworn declaration to all accounts who
            completed their profile.
          </p>
        </div>
      </div>
      <div className="grid grid-2 pt-2">
        <div className="col-span-2">
          <button
            type="submit"
            className="button button-primary disabled:opacity-70 disabled:cursor-not-allowed"
            disabled={isLoading}
          >
            {isLoading && <FaCircleNotch className="animate-spin mr-3" />}
            {!isLoading && <IoMailOutline className="mr-3" />}
            Send via Email
          </button>
        </div>
      </div>
    </form>
  );
};

export default SwornDeclarationForm;
